import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["fill"]


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardSvg',
  props: {
  width: {
    type: [String, Number],
    default: 37,
  },
  height: {
    type: [String, Number],
    default: 37,
  },
  fill: {
    type: String,
    default: 'currentColor',
  },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _mergeProps(_ctx.$attrs, {
    width: __props.width,
    height: __props.height,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), [
    _createElementVNode("path", {
      d: "M3.89474 15.8571V28.1905H9.73684V15.8571H3.89474ZM15.5789 15.8571V28.1905H21.4211V15.8571H15.5789ZM0 37H37V31.7143H0V37ZM27.2632 15.8571V28.1905H33.1053V15.8571H27.2632ZM18.5 0L0 8.80952V12.3333H37V8.80952L18.5 0Z",
      fill: __props.fill
    }, null, 8, _hoisted_2)
  ], 16, _hoisted_1))
}
}

})